<!--
Author: TangChen
Date: 2018-11-21
Desc: 基金超市
 -->
<template>
    <div>
        <div :class="'bizcomp-fund-market bizcomp ' + className">
            <comp-title :title="title" />
            <div class="fund-market">
                <el-row class="fund-filter">
                    <el-col v-if="isPublic" :span="24" class="btn-fund">
                        基金类型：
                        <el-radio-group v-model="fundCate" size="mini">
                            <el-radio-button
                                v-for="item in fundType"
                                :key="item.val"
                                :label="item.val"
                            >
                                {{ item.text }}
                            </el-radio-button>
                        </el-radio-group>
                    </el-col>
                    <el-col v-else :span="24" class="btn-fund">
                        基金策略类型：
                        <el-radio-group v-model="strategyType" size="mini">
                            <el-radio-button label="">全部</el-radio-button>
                            <el-radio-button
                                v-for="item in strategyTypeList"
                                :key="item.strategycode"
                                :label="item.strategycode"
                            >
                                {{ item.strategyname }}
                            </el-radio-button>
                        </el-radio-group>
                    </el-col>
                    <el-col v-if="isPublic" :span="24" class="btn-fund">
                        基金风险：
                        <el-radio-group v-model="fundRisk" size="mini">
                            <el-radio-button label="">全部</el-radio-button>
                            <el-radio-button
                                v-for="risk in riskList"
                                :key="risk.subitem"
                                :label="risk.subitem"
                            >
                                {{ risk.subitemname }}风险
                            </el-radio-button>
                        </el-radio-group>
                    </el-col>
                    <el-col v-else :span="24" class="btn-fund">
                        基金风险：
                        <el-radio-group v-model="ismatch" size="mini">
                            <el-radio-button label="0">全部</el-radio-button>
                            <el-radio-button label="1">只看风险匹配</el-radio-button>
                        </el-radio-group>
                    </el-col>
                    <!-- 基金经理 -->
                    <el-col :span="24" class="btn-fund fund-manager-row">
                        <span class="fund-label">基金经理：</span>

                        <!-- 全部：单独一列 -->
                        <el-radio-group v-model="fundManager" size="mini" class="fund-manager-all">
                            <el-radio-button label="">全部</el-radio-button>
                        </el-radio-group>

                        <!-- 基金经理列表 -->
                        <el-radio-group v-model="fundManager" size="mini" class="fund-manager-list">
                            <el-radio-button
                                v-for="item in fundManagerList"
                                :key="item.managerid"
                                :label="item.managerid"
                            >
                                {{ item.managername }}
                            </el-radio-button>
                        </el-radio-group>
                    </el-col>

                    <el-col :span="24" class="btn-search">
                        查询条件：
                        <span v-for="tag in dynamicTags" :key="tag" style="display: inline-block">
                            <el-tag
                                v-if="tag"
                                closable
                                :disable-transitions="false"
                                v-on:close="handleClose(tag)"
                            >
                                {{ tag }}
                            </el-tag>
                        </span>
                        <el-autocomplete
                            v-model="searchText"
                            popper-class="my-autocomplete"
                            placeholder="请输入查询基金名称或基金代码"
                            class="input-search"
                            :popper-append-to-body="false"
                            size="small"
                            :fetch-suggestions="querySearchAsync"
                            v-on:select="handleSelect"
                        >
                            <template slot-scope="{ item }">
                                <div class="name">
                                    {{ item.value }}
                                </div>
                            </template>
                        </el-autocomplete>
                        <el-button
                            class="btn-search-icon"
                            icon="el-icon-search"
                            type="primary"
                            size="small"
                            v-on:click="searchFund"
                        />
                    </el-col>
                    <el-col :span="24" class="btn-fund">
                        共有
                        <span class="red">{{ allPage }}</span>
                        条基金&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;排序：
                        <el-row v-model="sortVal" size="small" class="sort-btn">
                            <!--<el-button size="small" :type="sortVal==='sales'?'primary':''" @click="getVal('sales')">按销量<i :class="sort.sales?icond:iconu" aria-hidden="true"></i></el-button>-->
                            <el-button
                                size="small"
                                :type="sortVal === 'grow' ? 'primary' : ''"
                                v-on:click="getVal('grow')"
                            >
                                按涨跌幅
                                <i aria-hidden="true" :class="sort.grow.up ? icond : iconu" />
                            </el-button>
                            <el-button
                                size="small"
                                :type="sortVal === 'incomeAll' ? 'primary' : ''"
                                v-on:click="getVal('incomeAll')"
                            >
                                按成立以来收益
                                <i aria-hidden="true" :class="sort.incomeAll.up ? icond : iconu" />
                            </el-button>
                            <el-button
                                size="small"
                                :type="sortVal === 'income' ? 'primary' : ''"
                                v-on:click="getVal('income')"
                            >
                                按今年以来收益
                                <i aria-hidden="true" :class="sort.income.up ? icond : iconu" />
                            </el-button>
                            <!--                        <el-button size="small" :type="sortVal==='risk'?'yellow':''" v-on:click="getVal('risk')">
                            按风险<i
                                :class="sort.risk.up?icond:iconu"
                            />
                        </el-button> -->
                            <el-select
                                v-show="sortVal ? sort[sortVal].id === 'dayfloatprofit' : false"
                                v-model="growValue"
                                class="grow-class"
                                size="small"
                                placeholder="请选择区间"
                            >
                                <el-option
                                    v-for="item in growArea"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value"
                                ></el-option>
                            </el-select>
                        </el-row>
                    </el-col>
                </el-row>
                <fund-risk-filter v-if="isPublic" :qryall="ismatch" v-on:qry-change="qryChange" />
                <fund-list
                    ref="fundList"
                    :is-public="isPublic"
                    :fund-info="fund"
                    :fund-grow-qry="growValue"
                    :all-page="allPage"
                    v-on:new-fund="newFund"
                    v-on:fund-continue="fundBuy"
                />
            </div>
        </div>
        <footerQuestions v-if="url == 'glist'" :warning-html="warningHtml"></footerQuestions>
        <fund-sdx-dialog
            :fund="sdxFundInfo"
            :sdx-dialog-visible="sdxDialogVisible"
            v-on:dialogClosed="sdxDialogClose"
            v-on:dialogContinue="sdxDialogContinue"
        ></fund-sdx-dialog>
    </div>
</template>
<script>
import mixin from "@/assets/js/mixin";
import fundList from "@/components/fund/fundList.vue";
import fundRiskFilter from "@/components/form/fundRiskFilter.vue";
import fundApi from "@/api/fund";
import footerQuestions from "@/components/layout/footerQuestions.vue";
import warningHtml from "@/constant/warning_html.js";
import fundSdxDialog from "@/components/form/fundSdxDialog";
import { getRiskFilter, isValidProfessionalInvestor } from "@/util";

export default {
    name: "FundMarket",
    components: {
        fundList,
        fundRiskFilter,
        fundSdxDialog,
        footerQuestions
    },
    mixins: [mixin],
    data() {
        return {
            conf: {}, // 初始化配置文件内容
            fundCate: "", // 基金类型,默认全部类型
            fundRisk: "", // 基金风险
            ismatch: getRiskFilter(), // 是否只看风险匹配
            strategyType: "", // 基金策略类型
            strategyTypeList: [], // 策略类型数据
            searchText: "", // 搜索文本内容
            sortVal: "", // 排序字段
            lastSortVal: "", // 上次排序字段
            fund: [], // 基金信息
            dynamicTags: [], // 筛选条件
            queryFind: null, // 定时器
            allPage: "0", // 所有数据条数
            pagecount: 10, // 分页条数
            pageoffset: 1, // 起始页
            xjbCode: "", // 现金宝fundcodes
            riskList: [],
            url: "", // 当前页面路由命名
            isPublic: true, // 是否公募
            fundType: [],
            iconu: "el-icon-upload2",
            icond: "el-icon-download",
            sort: {
                incomeAll: {
                    id: "allud",
                    up: true
                },
                grow: {
                    id: "dayfloatprofit",
                    up: true
                },
                income: {
                    id: "thisyear1ud",
                    up: true
                },
                risk: {
                    id: "8",
                    up: false
                }
            },
            growArea: [
                {
                    value: "dayfloatprofit",
                    label: "日涨跌幅"
                },
                {
                    value: "month1ud",
                    label: "近一月涨跌幅"
                },
                {
                    value: "month3ud",
                    label: "近三月涨跌幅"
                },
                {
                    value: "month6ud",
                    label: "近六月涨跌幅"
                },
                {
                    value: "year1ud",
                    label: "近一年涨跌幅"
                },
                {
                    value: "year3ud",
                    label: "近三年涨跌幅"
                },
                {
                    value: "year5ud",
                    label: "近五年涨跌幅"
                },
                {
                    value: "allud",
                    label: "成立以来"
                }
            ],
            growValue: "",
            commonQuestion: [],
            warningHtml: "",
            sdxFundInfo: {},
            sdxDialogVisible: false,
            fundManager: "", // 当前选中基金经理
            fundManagerList: [], // 基金经理列表
            autoTradeHandledKey: ""
        };
    },
    watch: {
        "$route.fullPath"() {
            const routeFundcode = this.initRouteFundcode();
            this.pageoffset = 1;
            this.doAction(routeFundcode || "");
        },
        // 监测选项变化
        fundCate(val, from) {
            if (!val) {
                this.$set(this.dynamicTags, 0, "");
                // const _x = this.fundType.find(risk => {
                //     return risk.val === from;
                // });
                // this.dynamicTags.splice(this.dynamicTags.indexOf(_x.text), 1);
            } else {
                const _x = this.fundType.find((risk) => {
                    return risk.val === val;
                });
                this.$set(this.dynamicTags, 0, _x.text);
            }
            this.pageoffset = 1;
            this.doAction();
        },
        fundRisk(val, from) {
            if (!val) {
                this.$set(this.dynamicTags, 1, "");
            } else {
                const _x = this.riskList.find((risk) => {
                    return risk.subitem === val;
                });
                this.$set(this.dynamicTags, 1, _x ? _x.subitemname + "风险" : "");
            }
            this.pageoffset = 1;
            this.doAction();
        },
        growValue(val) {
            if (val) {
                this.doAction();
            }
        },
        sortVal(val) {
            if (this.sort[val].id !== "dayfloatprofit") {
                this.growValue = "";
            }
        },
        strategyType(val, from) {
            if (!val) {
                this.$set(this.dynamicTags, 0, "");
            } else {
                const _x = this.strategyTypeList.find((strategy) => {
                    return strategy.strategycode == val;
                });
                this.$set(this.dynamicTags, 0, _x.strategyname);
            }
            this.pageoffset = 1;
            this.doAction();
        },
        ismatch(val, from) {
            if (this.isPublic) {
                return;
            }
            if (!val) {
                this.$set(this.dynamicTags, 1, "");
            } else {
                const text = val == "0" ? "" : "只看风险匹配";
                this.$set(this.dynamicTags, 1, text);
            }
            this.pageoffset = 1;
            this.doAction();
        },
        fundManager(val) {
            if (!val) {
                this.$set(this.dynamicTags, 2, "");
            } else {
                const manager = this.fundManagerList.find((item) => item.managerid === val);
                this.$set(this.dynamicTags, 2, `基金经理：${manager.managername}`);
            }
            this.pageoffset = 1;
            this.doAction();
        }
    },
    created() {
        this.$store.commit("updateLoadFund", false);
        this.url = this.$route.name;
        this.isPublic = this.$route.name == "fund" || this.$route.name == "glist";
        if (this.isPublic) {
            const info = this.$cache.getUser();
            if (!isValidProfessionalInvestor()) {
                this.ismatch = info.ismatch || "1";
            }
            this.riskList = this.$cache.getDict("110143");
        } else {
            this.getFundStrategyType();
        }
        // this.pagecount = this.$util.getConfig().const.PAGE_SIZE;
        this.xjbCode = this.$cache.getXjbCode();
        this.initRouteFundcode();
        this.getFundTypes();
        this.doAction();
        this.warningHtml = warningHtml.warningHtml;
        this.commonQuestion = this.$const.commonQuestion.commonQuestion16;
        this.getFundManagerList();
    },
    mounted() {
        const routeFundcode = this.initRouteFundcode();
        this.getVal("grow");
        if (routeFundcode) {
            this.doAction(routeFundcode);
        }
    },
    methods: {
        getRouteFundcode() {
            return this.$util.filterCode((this.$route.query && this.$route.query.fundcode) || "");
        },
        initRouteFundcode() {
            const fundcode = this.getRouteFundcode();
            this.searchText = fundcode;
            this.autoTradeHandledKey = "";
            return fundcode || "";
        },
        getAutoTradeInfo() {
            const tradeRouteName = this.$route.query.autotrade || "";
            const fundcode = this.getRouteFundcode();
            const tradeWay =
                tradeRouteName === "buyfund"
                    ? "20,22"
                    : tradeRouteName === "generalbuy"
                    ? "59"
                    : "";
            if (!tradeWay || !fundcode) {
                return null;
            }
            return {
                fundcode,
                tradeWay,
                key: `${this.$route.name}_${tradeRouteName}_${fundcode}`
            };
        },
        handleAutoTrade(list) {
            const autoTradeInfo = this.getAutoTradeInfo();
            if (!autoTradeInfo || this.autoTradeHandledKey === autoTradeInfo.key) {
                return;
            }
            this.autoTradeHandledKey = autoTradeInfo.key;
            const targetFund = list.find((item) => item.fundcode === autoTradeInfo.fundcode);
            if (!targetFund) {
                this.$message.info("未查询到符合条件的数据！");
                return;
            }
            this.$nextTick(() => {
                const triggerResult =
                    this.$refs.fundList && this.$refs.fundList.triggerTradeByFundCode
                        ? this.$refs.fundList.triggerTradeByFundCode(
                              autoTradeInfo.tradeWay,
                              autoTradeInfo.fundcode
                          )
                        : { status: "missing" };
                if (triggerResult.status === "missing") {
                    this.fundBuy(autoTradeInfo.tradeWay, targetFund);
                }
            });
        },
        // 获取基金类型
        async getFundTypes() {
            let fundclassList =
                (this.$cache.getParamValue("fund_market") &&
                    this.$cache.getParamValue("fund_market").fundshowtypes) ||
                [];
            // 判断脚本是否有热销基金这项
            let hasTargetItem = fundclassList.some((item) => item.subitem === "47223");
            // 处理基金超市展示的列表项
            const convertedApiTabs = fundclassList.map((item) => ({
                val: item.subitem != "47223" ? item.subitem : "hot",
                text: item.subitemname
            }));
            if (hasTargetItem) {
                const res = await fundApi.getFundLists({
                    tagids: "47223",
                    pagesize: 10,
                    pagenum: 1
                });
                // 如果没有热销基金 不展示此tab
                if (res.data.list.length == 0) {
                    hasTargetItem = false;
                    convertedApiTabs.shift();
                }
            }
            this.fundType = this.isPublic
                ? convertedApiTabs
                : JSON.parse(JSON.stringify(this.$util.getConfig().privateFundTypes));
            this.fundCate = !this.isPublic ? "999" : hasTargetItem ? "hot" : "999";
            this.fundType.forEach((item) => {
                if (!item.val) {
                    item.val = "999";
                }
            });
        },
        // 获取排序数据
        getVal(val) {
            this.sortVal = val;
            if (this.sortVal === this.lastSortVal) {
                this.sort[val].up = !this.sort[val].up;
            } else {
                this.lastSortVal = this.sortVal;
            }
            this.doAction();
        },
        // 处理基金适当性信息
        fundBuy(way, val) {
            // 处理购买现金宝基金跳转
            if (this.xjbCode && this.xjbCode.indexOf(val.fundcode) > -1 && way === "20,22") {
                this.$router.push({ name: "currencycharge", query: { fundcode: val.fundcode } });
                return;
            }
            // 普通购买/定投
            if (way === "20,22") {
                val._url = "buyfund";
                val.proto = "buy";
            } else if (way === "59") {
                val._url = "generalbuy";
                val.proto = "plan";
            }
            this.$util.fundRiskCheck(this, val, (res) => {
                // if (res) {
                //     const _x = Object.assign({}, res, { way: way });
                //     sessionStorage.setItem(_url, JSON.stringify(_x));
                //     this.$router.push({ name: _url, query: { fundcode: res.fundcode } });
                // }
                console.log(res);
                if (res) {
                    const isNeedSdxCheck = this.$util.isNeedSdxCheck(val);
                    if (!isNeedSdxCheck) {
                        val.way = way; // 添加 way 字段，供 buyCompDC.vue 计算 isPwdCheck
                        this.$util.grantTradeSdxAccessAndStoreFund(val._url, val);
                        this.$router.push({ name: val._url, query: { fundcode: val.fundcode } });
                        return;
                    }
                    this.$util.getSdxProtocol(res, (data) => {
                        console.log(data);
                        if (data) {
                            const _x = Object.assign({}, data, { way: way });
                            this.sdxFundInfo = _x;
                            this.sdxDialogVisible = true;
                        }
                    });
                }
            });
        },
        sdxDialogClose() {
            this.sdxDialogVisible = false;
        },
        sdxDialogContinue() {
            this.sdxDialogVisible = false;
            this.$util.grantTradeSdxAccessAndStoreFund(this.sdxFundInfo._url, this.sdxFundInfo);
            this.$router.push({
                name: this.sdxFundInfo._url,
                query: { fundcode: this.sdxFundInfo.fundcode }
            });
        },
        // 搜索基金
        searchFund() {
            this.doAction(this.searchText);
        },
        // 获取策略类型数据
        async getFundStrategyType() {
            const res = await fundApi.getFundStrategyType();
            this.strategyTypeList = res.data || [];
        },
        // 改变风险过滤规则
        qryChange(val) {
            this.ismatch = val;
            this.pageoffset = 1;
            this.doAction();
        },
        // 获取下拉列表数据
        querySearchAsync(queryString, cb) {
            this.doAction(queryString, (res) => {
                let _cbArr = [];
                res.forEach((item, index) => {
                    let _x = {};
                    _x.value = item.fundname + "(" + item.fundcode + ")";
                    _x.id = item.fundcode;
                    _x.index = index;
                    _cbArr.push(_x);
                });
                cb(_cbArr);
            });
        },
        // 选中建议项
        handleSelect() {
            if (this.searchText.indexOf("(") != -1) {
                this.searchText = this.searchText.slice(0, this.searchText.indexOf("("));
            }
        },
        // 获取新一页数据
        newFund(val) {
            this.pageoffset = val;
            this.doAction();
        },
        // 获取基金信息
        async getFund(val, cb) {
            const _this = this;
            const exType = ["999", "0", "zghr", "hot"];
            const _x = {
                tagids: this.fundCate === "hot" ? "47223" : "",
                fundshowtype: exType.includes(this.fundCate) ? "" : this.fundCate,
                mrfflag: this.fundCate === "zghr" ? "1" : undefined,
                strategylevel1: this.strategyType,
                risklevel: this.fundRisk,
                ismatch: this.ismatch,
                fundclass: this.isPublic ? "0" : "1",
                smprodtype: "",
                orderfield: this.growValue
                    ? this.growValue
                    : this.sortVal
                    ? this.sort[this.sortVal].id
                    : "",
                isasc: this.sortVal ? (this.sort[this.sortVal].up ? "0" : "1") : "",
                valuagrbuystate: this.url === "glist" ? "1" : "",
                keyword: val || (this.searchText ? this.searchText : ""),
                pagesize: cb ? 20 : this.pagecount,
                pagenum: val ? 1 : this.pageoffset,
                issale: this.isPublic ? "" : "1",
                // qrysmflag: "1"
                tradingmethod: this.$util.getConfig().systemtype,
                managercode: this.fundManager
            };
            const res = await fundApi.getFundLists(_x);
            if (res.data) {
                this.$store.commit("updateLoadFund", true);
                if (!cb) {
                    _this.fund = res.data.list;
                    if (_this.isPublic) {
                        // 记录过滤状态
                        const info = _this.$cache.getUser();
                        info.ismatch = _this.ismatch;
                        _this.$store.dispatch("setInfo", info);
                    }
                    _this.allPage = res.data.total.toString();
                    _this.handleAutoTrade(res.data.list || []);
                } else {
                    cb.call(_this, res.data.list);
                }
            }
        },
        // 对基金频繁查询请求做处理
        doAction(val, cb) {
            const _this = this;
            if (cb) {
                val = this.$util.filterCode(val);
                this.searchText = val;
                if (val.length < 1) {
                    cb.call(this, []);
                    return false;
                }
            }
            clearTimeout(this.queryFind);
            this.queryFind = setTimeout(function () {
                _this.getFund(val, cb);
            }, 500);
        },
        // 搜索选项关闭处理
        handleClose(val) {
            // 查询条件标签按固定下标维护，避免按展示文案判断时误删其他筛选项。
            if (val === this.dynamicTags[2]) {
                this.fundManager = "";
                return;
            }
            if (this.isPublic) {
                if (val === this.dynamicTags[1]) {
                    this.fundRisk = "";
                } else {
                    this.fundCate = "";
                }
            } else {
                if (val == "只看风险匹配") {
                    this.ismatch = "0";
                } else {
                    this.strategyType = "";
                }
            }
        },
        async getFundManagerList() {
            const res = await fundApi.qryFundManagers();
            this.fundManagerList = res.data || [];
        }
    }
};
</script>

<style>
.my-autocomplete {
    width: auto !important;
}
</style>

<style scoped>
/* 基金经理整行 */
.fund-manager-row {
    display: flex;
    align-items: flex-start;
    white-space: normal;
}

/* label */
.fund-manager-row .fund-label {
    flex-shrink: 0;
    line-height: 28px;
    margin-right: 4px;
}

/* 全部 */
.fund-manager-all {
    flex-shrink: 0;
}

/* 基金经理列表 */
.fund-manager-list {
    display: flex;
    flex-wrap: wrap;
    flex: 1;
}

/* 每个基金经理宽度 */
.fund-manager-list .el-radio-button {
    width: 100px;
    box-sizing: border-box;
    margin-bottom: 6px;
}

/* 按钮内部 */
.fund-manager-row .el-radio-button__inner {
    width: 100%;
    padding: 6px 4px;
    text-align: center;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
</style>
<style>
.bizcomp-fund-market .el-radio-button__orig-radio:checked + .el-radio-button__inner {
    background-color: var(--color-primary) !important;
    border-color: var(--color-primary) !important;
    box-shadow: -1px 0 0 0 var(--color-primary) !important;
}
.bizcomp-fund-market .el-radio-button__inner:hover {
    color: var(--color-primary);
}
.bizcomp-fund-market .el-tag {
    color: var(--color-primary);
    background-color: var(--color-secondary);
    border-color: var(--color-secondary);
}
.bizcomp-fund-market .el-tag .el-icon-close {
    color: var(--color-primary);
}
.bizcomp-fund-market .el-tag .el-icon-close:hover {
    background-color: var(--color-primary);
    color: #fff;
}
.bizcomp-fund-market .red {
    color: var(--color-primary) !important;
}
</style>
